import React from "react";

import {Button, Col, Container, Row} from "reactstrap";
import dateHelpers from "../../helpers/DateHelper";
import ReactTooltip from 'react-tooltip'
import LocalizedStrings from "react-localization";
import localeHelpers from "../../helpers/LocaleHelper";
import {common_strings} from "../../translations/common_translations";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";
import HeaderAlert from "../Alerts/SuccessAlert";
import {Redirect} from "react-router-dom";
import businessHelper from "../../helpers/BusinessHelper";
import ProBadge from "../Alerts/ProBadge";
import {MdRefresh} from 'react-icons/md';
import placeholderHelper from "../../helpers/PlaceholderHelper";

let commonStrings = new LocalizedStrings(common_strings);
let studentStrings = new LocalizedStrings(student_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

class ClassHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            yclass: props.yclass
        };
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            yclass: nextProps.yclass,
            backToClass: nextProps.backToClass,
            backToUnpaidReport: nextProps.backToUnpaidReport
        });
    }

    gotoTeacher(index) {
        this.setState({goToTeacherWithIndex: index})
    }

    render() {
        this.localize();
        if (this.state.goToTeacherWithIndex >= 0) {
            return <Redirect from="*" to={{
                pathname: "/admin/teacher-profile",
                state: {
                    teacherId: this.state.yclass.teachers[this.state.goToTeacherWithIndex].id,
                    backToClassId: this.state.yclass.id,
                    backToClassName: this.state.yclass.name,
                }
            }}/>
        }

        return (
            <>
                <div
                    className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                    style={{
                        height: "400px",
                        backgroundImage: "url(" + businessHelper.backgroundImage("class_overview") + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }}
                >
                    {/* Mask */}
                    <span className="mask bg-gradient-dark opacity-9"/>
                    {/* Header container */}
                    <Container className="d-flex align-items-center" fluid>
                        <ReactTooltip/>
                        <Row>
                            <Col lg="12" md="12">
                                <Row>
                                    <h1 className="display-3 text-white ml-2 mr-3">{this.state.yclass ? this.state.yclass.name.substring(0, 32) : ""}</h1>
                                    {(this.state.yclass?.teachers || []).map((teacher, index) => {
                                        return<>

                                                <span style={{display: "flex", flexFlow: "column", alignItems: "center", justifyContent: "center"}}>
                                                <img
                                                    alt="teacher photo"
                                                    onClick={e => this.gotoTeacher(index)}
                                                    style={{
                                                        objectFit: "cover",
                                                        position: "relative",
                                                        imageOrientation: "from-image",
                                                        width: "40px",
                                                        height: "40px",
                                                        display: "inline-block",
                                                        borderRadius: "35px",
                                                        cursor: "pointer",
                                                    }}
                                                    src={this.teacherPhoto(index) || placeholderHelper.randomIcon()}
                                                />

                                                <label className="text-white ml-1"
                                                       style={{cursor: "pointer", marginTop: 6, padding: 0, fontSize: '0.7rem', fontWeight: 700, marginRight: 6}}
                                                       onClick={e => this.gotoTeacher(index)}
                                                       data-type="warning"
                                                       data-tip={resourceStrings.goToTeacher}><a href="#">{this.teacherName(index)}</a>
                                                </label>
                                                </span>

                                        </>
                                    })}
                                </Row>
                                <div style={{float: 'right', textAlign: "center"}}>
                                    <h1 className="display-2 text-white">{this.studentsCount()}</h1>
                                    <h5
                                         className="text-white">
                                        {this.confirmedCount() > 0 && <span><span className="text-white" style={{fontSize: "1.2rem"}}> {this.confirmedCount()} </span>{resourceStrings.confirmed.toLowerCase()} </span>}
                                        {this.cancelledCount() > 0 && <span><span className="text-white" style={{fontSize: "1.2rem"}}> {this.cancelledCount()} </span>{commonStrings.cancelled.toLowerCase()} </span>}
                                        {/*{studentStrings.students}*/}
                                    </h5>
                                </div>
                                <h4 className="text-white">{this.classDateTime()}</h4>
                                <small className="text-white">{(this.state.yclass && this.state.yclass.rooms && this.state.yclass.rooms.length > 0) ? this.state.yclass.rooms[0].name || "" : ""} </small>

                                <p className="text-white mt-0 mb-5">
                                    {/*This is your profile page. You can see the progress you've*/}
                                    {/*made with your work and manage your projects or assigned tasks*/}
                                    {(this.state.yclass && this.state.yclass.note) ? this.state.yclass.note : ""}
                                </p>
                                <div style={{marginTop: -30}}>
                                    {this.state.yclass && this.state.yclass.is_free &&
                                    <Button
                                        color="success"
                                        size="sm"
                                        onClick={e => e.preventDefault()}
                                    >
                                        {resourceStrings.free_class}
                                    </Button>
                                    }
                                    {this.state.yclass && this.state.yclass.is_online &&
                                    <Button
                                        color="info"
                                        size="sm"
                                    >
                                        {resourceStrings.online_class}
                                    </Button>
                                    }
                                    {this.state.yclass && this.state.yclass.is_workshop &&
                                    <Button
                                        color="success"
                                        size="sm"
                                    >
                                        {resourceStrings.workshop}
                                    </Button>
                                    }
                                    {this.renderClassPlan()}
                                </div>
                                {this.acceptedTicketTypes() !== null &&
                                <div className="ct-example-tooltip-static"
                                     onClick={e => this.explainRestrictedTicketTypes(e)}
                                     style={{marginTop: 6}}
                                >
                                    <i style={{color: "white", marginRight: 8}} className="fas fa-ticket-alt"/>
                                    <small
                                        data-tip={resourceStrings.formatString(resourceStrings.special_tickets_expl, this.acceptedTicketTypes())}
                                        style={{color: "white", marginRight: 8}} place={"bottom"}
                                        type="warning">{this.acceptedTicketTypes()} </small>
                                </div>
                                }
                            </Col>

                            {this.state.yclass &&
                            <Row style={{alignItems: 'flex-end', marginLeft: 16, marginBottom: 10}}>
                                {this.state.backToClass && this.state.backToClass.id !== this.state.yclass.id &&
                                <Button
                                    style={{marginTop: "2px", height: 43}}
                                    color="danger"
                                    onClick={e => this.props.navigateBack()}
                                >
                                    <span className="d-none d-md-block">
                                    <i style={{color: "white", marginRight: 8}} className="fas fa-edit"/>
                                    ⬅️ {commonStrings.back_to} {this.state.backToClass.name}
                                    </span>
                                    <span className="d-md-none">
                                        ⬅
                                    </span>

                                </Button>
                                }

                                {(this.props.backToClassReport || this.props.backToUnpaidReport) &&
                                <Button
                                    color="danger"
                                    onClick={e => this.backToReport(e)}
                                >
                                    ⬅️ {commonStrings.back_to} {commonStrings.navigation.report}
                                </Button>
                                }

                                <Button
                                    style={{marginTop: "2px", height: 43}}
                                    color="warning"
                                    onClick={e => this.props.editClassAction(e)}
                                >
                                    <span className="d-none d-md-block">
                                    <i style={{color: "white", marginRight: 8}} className="fas fa-edit"/>
                                        {resourceStrings.edit_class}
                                    </span>
                                    <span className="d-md-none">
                                        <i style={{color: "white"}} className="fas fa-edit"/>
                                    </span>
                                </Button>
                                <Button
                                    style={{marginTop: "2px", height: 43}}
                                    color="info"
                                    onClick={e => this.props.showExportData(e)}
                                >
                                    <span className="d-none d-md-block">
                                    <i style={{color: "white", marginRight: 8}} className="fas fa-file-download"/>
                                        {commonStrings.export_data} <ProBadge color={"white"}/>
                                    </span>
                                    <span className="d-md-none">
                                        <i style={{color: "white"}} className="fas fa-file-download"/><ProBadge
                                        color={"white"}/>
                                    </span>
                                </Button>
                                <Button
                                    style={{marginTop: "2px", height: 43}}
                                    color="success"
                                    onClick={e => this.props.showMessage(e)}
                                >
                                    <span className="d-none d-md-block">
                                    <i style={{color: "white", marginRight: 8}} className="fas fa-envelope"/>
                                        {commonStrings.send_message} <ProBadge color={"white"}/>
                                    </span>
                                    <span className="d-md-none">
                                        <i style={{color: "white"}} className="fas fa-envelope"/><ProBadge
                                        color={"white"}/>
                                    </span>
                                </Button>

                                <Button
                                    style={{marginTop: "2px", height: 43}}
                                    color="secondary"
                                    onClick={e => this.props.toggleScan(e)}
                                >
                                    <span className="d-none d-md-block">
                                    <i style={{color: "dark", marginRight: 8}} className="fas fa-qrcode"/>
                                        {commonStrings.scan_qr}
                                    </span>
                                    <span className="d-md-none">
                                        <i style={{color: "dark"}} className="fas fa-qrcode"/>
                                    </span>
                                </Button>

                                <Button
                                    style={{marginTop: "2px", height: 43}}
                                    color="primary"
                                    onClick={e => this.props.toggleFeedback(e)}
                                >
                                    <span className="d-none d-md-block">
                                    <img
                                        alt="..."
                                        width={24}
                                        className="mr-2"
                                        height={24}
                                        src={require("assets/img/icons/common/good-feedback.svg").default}/>
                                        {commonStrings.feedback} ({(this.state.yclass.feedbacks || []).length})
                                    </span>
                                    <span className="d-md-none">
                                        <img
                                            alt="..."
                                            width={24}
                                            height={24}
                                            src={require("assets/img/icons/common/good-feedback.svg").default}/>
                                    </span>
                                </Button>

                                <Button
                                    style={{marginTop: "2px", height: 43}}
                                    color="default"
                                    onClick={e => this.props.recheckTickets(e)}
                                >
                                        <MdRefresh size="24px" className="rotate-image"/>
                                </Button>
                            </Row>
                            }
                        </Row>
                        {this.props.alertData &&
                        <HeaderAlert alertData={this.props.alertData}/>
                        }
                    </Container>
                </div>
            </>
        );
    }

    teacherName(index) {
        if (this.state.yclass && this.state.yclass.teachers && this.state.yclass.teachers.length > 0) {
            return this.state.yclass.teachers[index].name.split(" ")[0]
        } else {
            return ""
        }
    }

    teacherPhoto(index) {
        if (this.state.yclass && this.state.yclass.teachers && this.state.yclass.teachers.length > 0) {
            return this.state.yclass.teachers[index].photo
        } else {
            return null
        }
    }

    studentsCount() {
        if (this.state.yclass) {
            const capacity = (this.state.yclass.rooms && this.state.yclass.rooms.length) > 0 ? `${this.state.yclass.rooms[0].capacity ? `/${this.state.yclass.rooms[0].capacity}` : ""}` : "";
            return `${this.state.yclass.students.length + this.state.yclass.bookings.length}${capacity}`
        } else {
            return "0"
        }
    }

    confirmedCount() {
        if (this.state.yclass) {
            if (this.state.yclass.confirmed_bookings && this.state.yclass.confirmed_bookings.length > 2) {
                const confirmations = (this.state.yclass.confirmed_bookings || "").replace("{", "").replace("}", "").split(",").map(id => parseInt(id));
                return `${confirmations.length}`
            }
            else {
                return 0
            }
        } else {
            return 0
        }
    }

    cancelledCount() {
        if (this.state.yclass) {
            if (this.state.yclass.cancelled_students && this.state.yclass.cancelled_students.length > 0) {
                return `${this.state.yclass.cancelled_students.length}`
            }
            else {
                return 0
            }
        } else {
            return 0
        }
    }

    classDateTime() {
        if (this.state.yclass && this.state.yclass.date) {
            console.log(`DATE ${this.state.yclass.date}`)
        }
        if (this.state.yclass) {
            let date = dateHelpers.formatDate(new Date(this.state.yclass.date));
            let time = this.formattedTime()


            return date + " " + time
        }
    }

    acceptedTicketTypes() {
        if (this.state.yclass && this.state.yclass.ticket_types && this.state.yclass.ticket_types.length > 0) {
            return this.state.yclass.ticket_types.map(function (elem) {
                return elem.name;
            }).join(", ")
        } else return null
    }

    explainRestrictedTicketTypes(e) {
        e.preventDefault();

        alert(resourceStrings.formatString(resourceStrings.special_tickets_expl, this.acceptedTicketTypes()))
    }

    formattedTime() {
        if (businessHelper.subUser().time_fmt === "us") {
            return dateHelpers.stringTimeToAM(this.state.yclass.start)
        } else {
            return this.state.yclass.start;
        }
    }

    renderClassPlan() {
        return (<>
            {this.state.yclass && this.state.yclass.class_plan && this.state.yclass.class_plan.title ?
                (
                    <Button color="secondary" size="sm" className="mt-2, mb-1"
                            onClick={e => this.props.showClassPlan(e)}>{this.state.yclass.class_plan.title}</Button>
                ) : (
                    <Button color="secondary" size="sm" className="mt-2, mb-1"
                            onClick={e => this.props.showClassPlan(e)}>{resourceStrings.add_class_plan}</Button>)}
        </>)
    }

    backToReport(e) {
        e.preventDefault();
        if (this.props.backToUnpaidReport) {
            this.props.goToUnpaidReport()
        }
        else if (this.props.backToClassReport) {
            this.props.goToClassReport()
        }
    }
}

export default ClassHeader;
